<template>
  <v-dialog width="500" v-model="editableDialog">
    <v-card>
      <v-card-title> Add user </v-card-title>
      <v-card-actions>
        <v-combobox
          color="primary"
          :model-value="selectedUsers"
          @update:model-value="selectedUsers = $event"
          @update:search="search"
          item-title="text"
          item-value="id"
          :items="getSearchItems"
          :loading="isSearching"
          :type="'search'"
          clearable
          multiple
          chips
          deletable-chips
          placeholder="Enter user email"
        />

        <v-btn
          @click="clickAddUsers(), (editableDialog = false)"
          :disabled="!selectedUsers"
          class="ml-2"
          small
          color="primary"
        >
          <v-icon class="mr-0" left small>mdi-plus</v-icon>
          Add
        </v-btn>
      </v-card-actions>
      <v-card-actions> </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { debounce } from 'lodash'

export default {
  name: 'UserAddDialog',
  props: {
    dialog: {}
  },
  data: () => ({
    selectedUsers: []
  }),
  computed: {
    ...mapState('userManagement', {
      shownUsers: (state) => state.items,
      loading: (state) => state.loading,
      searchResults: (state) => state.searchResults,
      isSearching: (state) => state.isSearching,
      storeDirtyItems: (state) => state.dirtyItems
    }),
    ...mapState('project', {
      currentProject: (state) => state.currentProject,
      isAdmin: (state) => state.currentProject.currentprojectuser.role === 'admin'
    }),
    ...mapState('users', {
      currentUser: (state) => state.currentUser
    }),
    ...mapGetters('userManagement', {
      getSearchItems: 'getSearchItems'
    }),
    editableDialog: {
      get() {
        return this.dialog
      },
      set(value) {
        this.$emit('update:dialog', value)
      }
    }
  },
  methods: {
    ...mapActions('userManagement', {
      fetchProjectUser: 'fetchItems',
      resetState: 'resetState',
      setParameter: 'setParameter',
      emptyDirtyItems: 'emptyDirtyItems',
      searchUsers: 'searchUsers',
      addUsers: 'addUsers',
      updateRoles: 'updateRoles',
      addDirtyItem: 'addDirtyItem',
      deleteItem: 'deleteItem'
    }),
    search: debounce(function (text) {
      if (text) {
        this.searchUsers({
          projectId: this.currentProject.id,
          email: text
        })
      }
    }, 300),
    async clickAddUsers() {
      const projectId = this.currentProject.id
      const {
        selected_year,
        selected_soil_type_revision,
        selected_stage_configuration_revision,
        selected_water_line_rule_revision,
        selected_bursting_parameter_revision
      } = this.currentProject.currentprojectuser
      await this.addUsers({
        projectId,
        selected_year,
        selected_soil_type_revision,
        selected_stage_configuration_revision,
        selected_water_line_rule_revision,
        selected_bursting_parameter_revision,
        userIds: this.selectedUsers.map((v) => v.value)
      })
      this.selectedUsers = []
      await this.resetState()
      await this.fetchProjectUser(this.currentProject.id)
    }
  }
}
</script>
